/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const downloadFile = (url: string) => {
  const inject = "fl_attachment/";
  const target = "/upload/";
  const indexToInjectAt = url.search(target) + target.length;
  const downloadableURL =
    url.slice(0, indexToInjectAt) + inject + url.slice(indexToInjectAt);
  const newWindow = window.open(
    downloadableURL,
    "_blank",
    "noopener,noreferrer"
  );
  if (newWindow) newWindow.opener = null;
};

export default downloadFile;
